// extracted by css-extract-rspack-plugin
export default {"OverflowLabel":"SortingDropdown-module__OverflowLabel__JeH5B","InlineLabel":"SortingDropdown-module__InlineLabel__cB1iu"};